/**
 * =========================================================================================
 * Component - Country Mobile Component
 * =========================================================================================
 * Country Mobile Component
 * code: 'IN'
 * phone: ''
 *
 **/

import React, {useEffect, useRef, useState} from 'react';
import {constant} from "../../constant";
import Select, {components} from "react-select";
import {joinContact, spiltContact} from "../../common";
import useEscKey from "../../../app-account/common/useEscKey";
import useOutsideClick from "../../../app-account/common/useOutsideClick";

const UCountryMobile = React.memo((props) => {
    const dropdownRef = useRef();
    const [toggle, setToggle] = useState(false);
    const [state, setState] = useState({
        code: '',
        dial_code: '',
        phone: '',
    })

    useOutsideClick(dropdownRef, () => setToggle(false));
    useEscKey(() => setToggle(false));

    useEffect(() => {
        setState({
            code: props.code ? props.code : props.phone ? ((constant.COUNTRY_CODE.find(e => e.dial_code === spiltContact(props.phone)[0])?.code) || 'IN') : 'IN',
            dial_code: props.phone ? spiltContact(props.phone)[0] : '+91',
            phone: props.phone ? spiltContact(props.phone)[1] : '',
        })
    }, [props.phone, props.code]);

    useEffect(() => {
        const menuList = document.querySelector('.u_country-dropdown .u_select__menu-list')

        const selectScrollTop = document.querySelector('.u_country-dropdown .u_select__option--is-selected')?.offsetTop;
        if (menuList) menuList.scrollTop = selectScrollTop;
    }, [dropdownRef?.current]);

    const handle = {
        selectCode: (data) => {
            setToggle(false)
            const local = {...state, dial_code: data?.dial_code, code: data?.code}
            setState(local)
            if (props.onChange) props.onChange({code: data?.code, phone: joinContact(local.dial_code, local.phone)});
        },
        phone: e => {
            const local = {...state, phone: e.target.value}
            setState(local)
            if (props.onChange) props.onChange({
                code: state.code, phone: joinContact(local.dial_code, local.phone)
            });
        },
    }
    return (

        <div className="u_flex u_country">
            <div className={`u_country-section ${toggle ? 'u_active-dropdown' : ''}`} ref={dropdownRef}>
                <span className="u_country-selected u_flex u_align-center u_cp" onClick={() => setToggle(!toggle)}>
                    <i className={`u_flag ${state?.code}`}/>
                    {state.dial_code}
                </span>
                <div className={`u_country-dropdown`}>
                    {toggle && <ul className="u_country-dropdown-menu">
                        <Select
                            name="search country"
                            isSearchable={true}
                            className="u_select"
                            classNamePrefix="u_select"
                            placeholder="Search For Country"
                            onChange={handle.selectCode}
                            options={constant.COUNTRY_CODE}
                            autoFocus={true}
                            menuIsOpen={toggle}
                            menuPlacement="auto"
                            components={{
                                DropdownIndicator: () => null,
                                Option: (props) => {
                                    return (
                                        <components.Option {...props}
                                                           isSelected={props?.data?.dial_code === state?.dial_code}>
                                            <li className="u_country-list u_cp">
                                        <span className="u_country-list-code" rel={props?.data?.dial_code}>
                                            <i className={`u_flag ${props?.data?.code}`}/>
                                            {props?.data?.label} {props?.data?.dial_code}
                                        </span>
                                            </li>
                                        </components.Option>
                                    )
                                },
                            }}
                        />
                    </ul>}
                </div>
            </div>
            <div className="u_form-phonenum">
                <input
                    min={0}
                    type="number"
                    onWheelCapture={e => e.target.blur()}
                    placeholder=" "
                    name='phoneNumber'
                    onChange={handle.phone}
                    value={state?.phone}
                    onKeyDown={e => ["e", "E", "+", "-", "."].includes(e.key) && e.preventDefault()}
                    autoComplete="off"
                />
            </div>
        </div>
    );
});

export default UCountryMobile;